import { Add } from "@mui/icons-material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useCallback, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  CODE,
  DISCOUNT,
  LIMIT,
  ORDER,
  ORDER_BY,
  PAGE,
  PRODUCT,
  STATUS,
} from "src/constants/searchParams";
import { toNumber } from "src/utils/toNumber";
import { useGetCouponsQuery } from "src/api/services/couponsApi";
import CouponsTable from "./components/CouponsTable";
import NewCouponModal from "./components/NewCouponModal";
import { filters } from "./utils/filters";
import TableFilter from "src/components/TableFilter";

const Coupons = () => {
  const [params] = useSearchParams();
  const [open, setOpen] = useState<boolean>(false);

  const page = useMemo(() => toNumber(params.get(PAGE)), [params]);
  const limit = useMemo(() => toNumber(params.get(LIMIT)), [params]);

  const from = useMemo(() => {
    return page * limit;
  }, [limit, page]);

  const to = useMemo(() => {
    return from + limit - 1;
  }, [limit, from]);

  const queryParams = useMemo(
    () => ({
      order_by: params.get(ORDER_BY) ?? undefined,
      ascending: params.get(ORDER) === "asc" ? true : false,
      is_active: params.get(STATUS) ?? undefined,
      amount: params.get(DISCOUNT) ?? undefined,
      name: params.get(CODE) ?? undefined,
      product_name: params.get(PRODUCT) ?? undefined,
      from,
      to,
    }),
    [from, params, to]
  );

  const { data } = useGetCouponsQuery(queryParams);

  const { records, count } = useMemo(() => {
    if (data == null) return { records: [], count: 0 };

    return data;
  }, [data]);

  const handleOpenModal = useCallback(() => setOpen((o) => !o), []);

  return (
    <Stack gap="2rem">
      <Typography variant="h4" fontWeight={600}>
        Marketing codes
      </Typography>
      <Stack direction="row" gap={2}>
        {filters.map((filter) => (
          <TableFilter current={filter} key={filter.name} />
        ))}

        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={handleOpenModal}
        >
          Add code
        </Button>
      </Stack>

      <CouponsTable records={records} total={count} />

      <NewCouponModal open={open} onClose={setOpen} />
    </Stack>
  );
};

export default Coupons;
